import React, { useMemo } from 'react';

import { parseNestedAdfDocument } from '@confluence/macro-utils/entry-points/nestedAdfRenderer.ts';
import { expValEquals } from '@confluence/feature-experiments';

import { PageIncludeContextProvider } from '../contexts/PageIncludeContext.tsx';
import type { PageIncludeRendererWrapperProps, ResolvedTarget } from '../pageIncludeMacroTypes.ts';

export type PageIncludeContentProps = {
	resolvedTarget: ResolvedTarget;
	adfString: string;
	mediaToken?: string;
	macroId?: string;
	RendererWrapper: React.ComponentType<PageIncludeRendererWrapperProps>;
};

export const PageIncludeContent = ({
	resolvedTarget,
	adfString,
	mediaToken,
	macroId,
	RendererWrapper,
}: PageIncludeContentProps): React.JSX.Element => {
	const adfDocument = useMemo(() => parseNestedAdfDocument(adfString), [adfString]);
	const adfContent = adfDocument.content;

	return (
		<PageIncludeContextProvider contentId={resolvedTarget.contentId} title={resolvedTarget.title}>
			<RendererWrapper
				adf={adfContent}
				targetContentId={resolvedTarget.contentId}
				targetSpaceKey={resolvedTarget.spaceKey}
				targetSpaceId={resolvedTarget.spaceId}
				mediaToken={mediaToken}
				headingIdPrefix={
					expValEquals('confluence_toc_included_content_exp', 'isEnabled', true)
						? macroId
						: undefined
				}
			/>
		</PageIncludeContextProvider>
	);
};
